package com.neurobs.ccabserver.subjectsessionview.states

import com.neurobs.ccab.DatabaseCache
import com.neurobs.ccab.db.{StudyData, TestAnalysisData, TestData}
import com.neurobs.js.ccab.CCABServer
import com.neurobs.js.util.ServerResponseUtil
import com.neurobs.react.{GenericState, GenericStateGenerator, RegisteredChangeAttribute, ServerDataAttribute, StateAttribute}
import org.scalajs.dom.console
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks._
import slinky.core.facade.ReactElement

class TestRunAnalysisCache extends DatabaseCache[Seq[TestAnalysisData]]

case class TestAnalysisState (
  testsState: ServerDataAttribute[List[TestData]],
  testRunAnalysisCacheState: StateAttribute[TestRunAnalysisCache],
  cacheUpdateState: RegisteredChangeAttribute,
                             ) extends GenericState {

  def analysisCache = testRunAnalysisCacheState.value
  def searchCache(testRunId: Long) = analysisCache.searchCache(testRunId)

  def loadTests() = {
    CCABServer.getTests(ServerResponseUtil.handleObjectResponse[Seq[TestData]](
      handleObject = data => testsState.setData(data.toList),
      onError = testsState.setError(_)
    ))
  }

  def loadAnalysis(testRunId: Long, required: Boolean = true) = {
    CCABServer.getTestAnalyses(testRunId, required)(handleServerAnalysis(testRunId))
  }

  def handleServerAnalysis(testRunId: Long) = ServerResponseUtil.handleObjectResultResponse[Seq[TestAnalysisData]](
    handleObject = data => {
      analysisCache.updateCache(testRunId, data)
      cacheUpdateState.register()
    },
    onAnyError = error => {
      analysisCache.updateCache(testRunId, error)
      cacheUpdateState.register()
    }
  )
}

object TestAnalysisStateGenerator extends GenericStateGenerator[TestAnalysisState] {
  override def generateEmptyDefaultState(): TestAnalysisState = TestAnalysisState(
    emptyServerDataState[List[TestData]](),
    emptyDefaultState(new TestRunAnalysisCache()),
    emptyRegisteredChangeState()
  )
}

@react
object TestAnalysisStateProvider {
  case class Props(children: ReactElement*)
  val component = FunctionalComponent[Props] { props =>

    val runSelectionState = RunSelectionStateGenerator.accessState

    val testsState = ServerDataAttribute(useState[Either[Option[String], List[TestData]]](Left(None)))
    val testRunAnalysisCacheState = StateAttribute(useState(new TestRunAnalysisCache()))
    val cacheUpdateState = RegisteredChangeAttribute(useState(0))


    val testAnalysisState = TestAnalysisState(
      testsState = testsState,
      testRunAnalysisCacheState = testRunAnalysisCacheState,
      cacheUpdateState = cacheUpdateState
    )

    useEffect(() => {
      testAnalysisState.loadTests()
    }, Vector())

    useEffect(() => {
      runSelectionState.selectedRunState.value.map(selectedRun => {
        selectedRun.testRun.map(testRun => {
          //testAnalysisState.loadAnalysis(testRun.testRun.id)
        })
      })
    }, Vector(runSelectionState.selectedRunState.value))

    TestAnalysisStateGenerator.Provider(testAnalysisState)(
      props.children:_*
    )


  }
}
